import { render, staticRenderFns } from "./PermissionsGrid-comp.vue?vue&type=template&id=d20404ca&scoped=true&"
import script from "./PermissionsGrid-comp.vue?vue&type=script&lang=js&"
export * from "./PermissionsGrid-comp.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsGrid-comp.vue?vue&type=style&index=0&id=d20404ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20404ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardText,VChip,VForm,VIcon,VListItem,VTextField})
